import React, {Component} from "react";
import * as PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import {items} from "../../index";
import {ItemHint} from "./ItemHint";
import "./ItemSmall.less"

export const rankMap = {
  'none': {
    order: -1,
  },
  '[Normal]': {
    order: 0,
  },
  '[Magic]': {
    order: 1,
  },
  '[Rare]': {
    order: 2,
  },
  '[Epic]': {
    order: 3,
  },
};

const grades = [
  {
    name: 'Deltirama',
    color: '#C39BE1'
  },
  {
    name: 'Neptinos',
    color: '#9BE1E1'
  },
  {
    name: 'Gnosis',
    color: '#DC143C'
  },
  {
    name: 'Alteia',
    color: '#99FF99'
  },
  {
    name: 'Arcana',
    color: '#733CBE'
  }
];

export const getGrade = grade => {
  return grades[grade - 1];
};

export const getSlot = name => {
  const slots = {
    head: ['Headwear'],
    body: ['Armor'],
    weapon: ['Weapon (Shared)', 'Weapon (Melee)', 'Weapon (Staff)', 'Weapon (Bow)', 'Weapon (Gun)', 'Weapon (Bag)'],
    wing: ['Wings'],
    ring: ['Accessory']
  };
  const item = getItem(name);
  if (!item) return null;
  for (let [slot, types] of Object.entries(slots)) for (let type of item.type) if (types.includes(type)) return slot;
  return null;
};

export const getItem = name => {
  const match = items.filter(item => item.name === name);
  return match.length ? match[0] : null;
};

export const getRecipe = (name, recursive = false) => {
  const item = getItem(name);
  if (!item || !item.recipe) return null;
  const recipe = item.recipe.slice();
  if (recursive)
    for (const ingredient of recipe)
      Object.entries(ingredient).forEach(([k, c]) => ingredient[k] = getRecipe(k, recursive) || c);
  return recipe;
};

export class ItemSmall extends Component {
  render() {
    const {inline, name, ...rest} = this.props;
    const item = getItem(name);
    return <span {...rest} className={'item-small' + (inline ? ' inline' : '')} style={{color: item && ('#' + item.color.toString(16).padStart(6,0))}}>
      {item && <ItemHint name={item.name}><ReactMarkdown source={item.name}/></ItemHint>}
    </span>;
  }
}

ItemSmall.propTypes = {
  name: PropTypes.string,
  inline: PropTypes.bool,
};